import React from "react";
import { Table, Pagination, CircularProgress } from "@ann/web-components";
import Icon from "../../../../../../../../../elements/icon/Icon";
import { 
  TableWrapper, 
  TableContainer, 
  PaginationWrapper, 
  LoadingContainer, 
  NoDataWrapper, 
  NoDataTitle, 
  NoDataDescription 
} from "./UsersTableSection.styled";

const UsersTableSection = ({
  tableData,
  headers,
  currentPage,
  itemsPerPage,
  onItemsPerPageChange,
  onPageChange,
  totalItems,
  totalPages,
  loading,
  error,
  isEmpty,
}) => {
  const showEmptyState = !loading && (isEmpty || tableData.length === 0);

  return (
    <TableWrapper>
      <TableContainer>
        {loading ? (
          <LoadingContainer>
            <CircularProgress size="xl" />
          </LoadingContainer>
        ) : showEmptyState ? (
          <NoDataWrapper>
            <Icon name="noDataAvailable" width="201px" height="195px" />
            <NoDataTitle>
              {error ? "Error loading users" : "No users yet"}
            </NoDataTitle>
            <NoDataDescription>
              {error 
                ? "Unable to load users. Please try again later."
                : "No users found in this department."}
            </NoDataDescription>
          </NoDataWrapper>
        ) : (
          <Table
            data={tableData}
            headers={headers}
            mode="table"
            showActions={false}
          />
        )}
      </TableContainer>
      {!showEmptyState && (
        <PaginationWrapper>
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={onItemsPerPageChange}
            onPageChange={onPageChange}
            totalItems={totalItems}
            totalPages={totalPages}
            disabled={loading}
          />
        </PaginationWrapper>
      )}
    </TableWrapper>
  );
};

export default UsersTableSection;
